"use client"
import React, { useState, useEffect } from "react";
import { Alert } from "react-bootstrap";

export const LocalStorageAlert = ({
  ls,
  type,
  heading,
  text,
  acceptText = "Got it"
}) => {
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    if (ls) {
      if (typeof window !== "undefined") {
        const localStorageItem = localStorage.getItem(`urality-${ls}`);
        setShowAlert(localStorageItem !== "true");
      }
    }
  }, [ls]);

  const setLocalStorageKey = () => {
    if (typeof window !== "undefined") {
      localStorage.setItem(`urality-${ls}`, "true");
    }
  };

  if (showAlert) {
    return (
      <Alert
        key={`lsa-${ls}`}
        variant={type?.toLowerCase()}
        className="local-storage-alert"
        onClick={() => {
          setShowAlert(false);
          setLocalStorageKey();
        }}
      >
        {heading && <Alert.Heading>{heading}</Alert.Heading>}
        {text && <p>{text}</p>}
        {acceptText && (
          <button
            type="button"
            className="a"
            onClick={() => {
              setShowAlert(false);
              setLocalStorageKey();
            }}
          >
            {acceptText}
          </button>
        )}
      </Alert>
    );
  } else {
    return <></>;
  }
};

export default LocalStorageAlert;
